{
  "adminSignInLink": {
    "body": "Klike sou bouton ki anba a pou jwenn aksè nan pòtal admin Pointcare ou a.",
    "cta": "Konekte nan admin",
    "greeting": "Bonjou,",
    "ignore": "Si se pa ou ki te mande aksè admin, ou ka inyore imèl sa a.",
    "linkFallback": "Si bouton an pa mache, kopye epi kole lyen sa a:",
    "signoff": "Mèsi,\nEkip Pointcare a",
    "subject": "Lyen koneksyon admin Pointcare ou a"
  },
  "reset": {
    "body": "Nou resevwa yon demann pou reyinisyalize modpas kont Pointcare ou a. Klike sou bouton ki anba a pou kreye yon nouvo.",
    "cta": "Reyinisyalize modpas mwen",
    "greeting": "Bonjou,",
    "ignore": "Si se pa ou ki te fè demann sa a, ou ka inyore imèl sa a san danje. Modpas ou p ap chanje.",
    "signoff": "Mèsi,\nEkip Pointcare a",
    "subject": "Reyinisyalize modpas Pointcare ou a"
  },
  "signInLink": {
    "body": "Tape bouton ki anba a pou konfime imèl ou epi konfigire kont Pointcare ou a.",
    "cta": "Konfime imèl mwen",
    "greeting": "Bonjou,",
    "ignore": "Ou pa t enskri pou Pointcare? Ou ka inyore imèl sa a.",
    "linkFallback": "Si bouton an pa mache, kopye epi kole lyen sa a:",
    "signoff": "Mèsi,\nEkip Pointcare a",
    "subject": "Konfime imèl ou pou Pointcare"
  }
}
